import getDefaultPlotFontSettings from "views/components/visualizations/utils/getDefaultPlotFontSettings";
import { AXIS_LABEL_MARGIN } from "views/components/visualizations/Constants";
const getDefaultPlotYLayoutSettings = (theme, unitTypeKey, config) => {
  var _a, _b, _c, _d;
  const visualizationAxisTitle = (config == null ? void 0 : config.visualizationConfig) && "axisConfig" in config.visualizationConfig ? (_b = (_a = config.visualizationConfig.axisConfig) == null ? void 0 : _a[unitTypeKey]) == null ? void 0 : _b.title : null;
  const visualizationAxisColor = (config == null ? void 0 : config.visualizationConfig) && "axisConfig" in config.visualizationConfig ? (_d = (_c = config.visualizationConfig.axisConfig) == null ? void 0 : _c[unitTypeKey]) == null ? void 0 : _d.color : null;
  const fontSettings = getDefaultPlotFontSettings(theme);
  const color = visualizationAxisColor != null ? visualizationAxisColor : fontSettings.color;
  const gridColor = visualizationAxisColor ? theme.utils.colorLevel(visualizationAxisColor, -4) : theme.colors.variant.lightest.default;
  return {
    automargin: true,
    gridcolor: gridColor,
    tickfont: { ...fontSettings, color },
    title: {
      font: { ...fontSettings, color },
      text: visualizationAxisTitle,
      automargin: true,
      standoff: AXIS_LABEL_MARGIN
    }
  };
};
export default getDefaultPlotYLayoutSettings;
